import { SortableTable, SortByConfig } from "components/Table/Table";
import { getFleetTableColumns } from "components/OverviewPages/getFleetTableColumns";

import { FleetOverview } from "interfaces/fleet-overview";
import { Row } from "react-table";

import { Paper } from "@mui/material";
import { useHistory } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { useContext, useEffect, useRef } from "react";
import { FeaturesContext } from "contexts/FeaturesContext";

export interface FleetTableProps {
  fleetTableData: FleetOverview[];
  loading: boolean;
  selectedSiteName: string;
}

const FleetTableDefaultSort: SortByConfig[] = [
  {
    id: "site",
    desc: false
  }
];

export const FleetTable = ({
  fleetTableData,
  loading,
  selectedSiteName
}: FleetTableProps): JSX.Element => {
  const history = useHistory();
  const { hasFeature } = useContext(FeaturesContext);

  const onRowClicked = (row: Row<FleetOverview>): void => {
    history.push(`/pages/site/${row.original.id}`);
  };

  const scrollRef = useRef<HTMLDivElement>(null);
  const rowsRef = useRef<(HTMLTableRowElement | null)[]>([]);

  useEffect(() => {
    const rowIndex = fleetTableData.findIndex(
      fleet => fleet.site === selectedSiteName
    );

    // get the offset from the top of the row selected minus the size of the sticky header
    const offsetTop = (rowsRef.current[rowIndex]?.offsetTop ?? 0) - 65;
    scrollRef.current?.scrollTo({ top: offsetTop, behavior: "smooth" });
  }, [selectedSiteName, fleetTableData]);

  return (
    <FleetTableScroll ref={scrollRef} elevation={0}>
      <SortableTable
        data={fleetTableData}
        columns={getFleetTableColumns(hasFeature)}
        onClickRow={onRowClicked}
        loading={loading}
        dataQa="fleet-table"
        isRowSelected={fleetOverview => fleetOverview.site === selectedSiteName}
        defaultSortBy={FleetTableDefaultSort}
        rowsRef={rowsRef}
      />
    </FleetTableScroll>
  );
};

const FleetTableScroll = styled(Paper)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
  margin: 24px;
  border: 1px solid rgba(224, 224, 224, 1);
  border-radius: 4px;
`;
